// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Proposal } from './proposal';
import {
    ProposalFromJSON,
    ProposalFromJSONTyped,
    ProposalToJSON,
    ProposalToJSONTyped,
} from './proposal';

/**
 * 
 * @export
 * @interface ProposalsListResponse
 */
export interface ProposalsListResponse {
    /**
     * 
     * @type {string}
     * @memberof ProposalsListResponse
     */
    dta_id: string;
    /**
     * 
     * @type {Array<Proposal>}
     * @memberof ProposalsListResponse
     */
    proposals: Array<Proposal>;
    /**
     * 
     * @type {number}
     * @memberof ProposalsListResponse
     */
    total: number;
}

/**
 * Check if a given object implements the ProposalsListResponse interface.
 */
export function instanceOfProposalsListResponse(value: object): value is ProposalsListResponse {
    if (!('dta_id' in value) || value['dta_id'] === undefined) return false;
    if (!('proposals' in value) || value['proposals'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function ProposalsListResponseFromJSON(json: any): ProposalsListResponse {
    return ProposalsListResponseFromJSONTyped(json, false);
}

export function ProposalsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalsListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dta_id': json['dta_id'],
        'proposals': ((json['proposals'] as Array<any>).map(ProposalFromJSON)),
        'total': json['total'],
    };
}

export function ProposalsListResponseToJSON(json: any): ProposalsListResponse {
    return ProposalsListResponseToJSONTyped(json, false);
}

export function ProposalsListResponseToJSONTyped(value?: ProposalsListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dta_id': value['dta_id'],
        'proposals': ((value['proposals'] as Array<any>).map(ProposalToJSON)),
        'total': value['total'],
    };
}
